<template>
  <div v-if="show" class="dialog-popup">
    <h5 class="dialog-title">{{ title }}</h5>
    <textarea
      v-model="comments"
      v-if="showComment"
      class="form-control comment-area"
      placeholder="Leave a comment for reference"
      rows="3"
    ></textarea>
    <div class="d-flex justify-content-end mt-2">
      <MsButton
        class="me-2"
        :buttonSize="ButtonSize.Small"
        buttonFont="NKT-P2-medium"
        @click="confirm"
      >
        Confirm <i class="ms-check-icon fe fe-check"></i>
      </MsButton>
      <MsButton :buttonSize="ButtonSize.Small" buttonFont="NKT-P2" @click="cancel">
        Cancel <span class="ms-x-icon fe fe-x"></span>
      </MsButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue'
import MsButton from '../general/buttons/MsButton.vue'
import { ButtonSize } from '@/utilities/enums'

defineProps({
  title: {
    type: String,
    default: 'Confirm Action'
  },
  show: {
    type: Boolean,
    default: false
  },
  showComment: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['confirm', 'cancel'])

const comments = ref('')

function confirm() {
  emit('confirm', comments.value)
  comments.value = ''
}

function cancel() {
  emit('cancel')
  comments.value = ''
}
</script>

<style scope lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.dialog-popup {
  position: absolute;
  right: 0;
  bottom: 100%;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 12px;
  z-index: 1000;
  width: 250px;

  .btn {
    .ms-check-icon {
      color: green;
      width: 24px;
    }

    .ms-x-icon {
      color: red;
      width: 24px;
    }
  }
}

.dialog-title {
  font-size: 14px;
  margin-bottom: 10px;
}

.comment-area {
  border: 1px solid color.$color-nordic-blue-base;
  resize: none;
}
</style>
